import { useQuery } from '@tanstack/react-query';
import { SUPPORTBFF_URL } from '@zapier/product-get-help';

const QUERY_KEY = 'currentUser';
const SUPPORT_BFF_ENDPOINT = '/get_current_user';

export type CurrentUser = {
  id: string | null;
  identity: number;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string;
  isLoggedIn: boolean;
  switches: { [key: string]: boolean };
};

const fetchCurrentUser = async (): Promise<{
  currentUser: CurrentUser;
}> => {
  const response = await fetch(`${SUPPORTBFF_URL}${SUPPORT_BFF_ENDPOINT}/`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch current user from supportbff.');
  }

  return response.json();
};

const useCurrentUser = (): {
  error: unknown;
  isLoading: boolean;
  user?: CurrentUser;
} => {
  const { error, data, isLoading } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: fetchCurrentUser,
    staleTime: 60000, // 60 seconds
  });

  return {
    error,
    isLoading,
    user: data && data.currentUser,
  };
};

export default useCurrentUser;
